<template>
  <p class="text-block">
    <slot></slot>
  </p>
</template>

<script>
export default {};
</script>

<style scoped>
.text-block {
  font-size: 14px;
  color: inherit;
  text-align: justify;
}
</style>
